import listViewStore from 'owa-mail-list-store/lib/store/Store';
import { select } from 'satcheljs/lib/legacy';
/**
 * Get all the table views that may contain items from the given folder
 * @param the folder id
 * @param shouldIncludeSearchTable - whether to include the search table in the table list being returned
 * @param the GetAllTableViewsContainingItemsForFolderState used for getAllTableViews
 */
export default select({
    tableViews: function () { return listViewStore.tableViews; },
})(function getAllTableViewsContainingItemsForFolder(folderId, shouldIncludeSearchTable, state) {
    var tableViews = state.tableViews;
    var allTableViewsOfFolder = [];
    tableViews.forEach(function (tableView) {
        // Include search table if specified
        if (tableView.tableQuery.folderId == folderId ||
            (shouldIncludeSearchTable && tableView.tableQuery.type == 1 /* Search */)) {
            allTableViewsOfFolder.push(tableView);
        }
    });
    return allTableViewsOfFolder;
});
//# sourceMappingURL=getAllTableViewsContainingItemsForFolder.js.map